import { Observable } from "rxjs";
import { HttpClientService } from "../service/http-client.service";
import { ZipCityAutocompletionRequestModel } from "../model/zip-city-autocompletion/zip-city-autocompletion-request.model";
import { ZipCityAutocompletionResponseModel } from "../model/zip-city-autocompletion/zip-city-autocompletion-response.model";

export class ZipCityAutocompletionRepo {
  /*
   * example endpoint
   * @see https://zip-api.eu/api/v1/codes/postal_code=DE-57518
   */

  protected static getEndpointUrl(): string {
    return location.origin;
  }

  static getCitiesByZipCode(
    countryCode: string,
    postalCode: string,
  ): Observable<ZipCityAutocompletionResponseModel[]> {
    const requestModel = new ZipCityAutocompletionRequestModel();
    requestModel.countryCode = countryCode;
    requestModel.postalCode = postalCode;

    const url = new URL(this.getEndpointUrl());
    url.pathname = "/user/zipcode-info";

    return HttpClientService.get(
      `${url.toString()}?countryCode=${requestModel.countryCode}&zipcode=${
        requestModel.postalCode
      }`,
    );
  }
}
